const RootController = require("./common/RootController");
const NavigationManager = require("./common/NavigationManager");
const ResourcesModel = require("./common/ResourcesModel");
const ConnectionPlugin = require("./connect/ConnectionPlugin");
const LogonPlugin = require("./logon/LogonPlugin");
const AttributesPlugin = require("./attributes/AttributesPlugin");
const AboutPlugin = require("./about/AboutPlugin");
const InfoPlugin = require("./info/InfoPlugin");
const FeatureTable = require("./common/FeatureTable");
const Utils = require("./common/Utils");
const postal = require("./common/PubSub");
const CudaLaunchCommon = require("./CudaLaunchCommon");
const FavouritesController = require("./favourites/FavouritesController");

function CudaLaunchApp() {
    CudaLaunchCommon();

    const featureTable = new FeatureTable();
    $.extend(window.App, {
        getFeatureTable : function() {
            return featureTable;
        }
    });

    $(document).on("loadappmodules", function() {
        new AboutPlugin().start();
        new InfoPlugin().start();
    });

    $(document).on("userauthenticated", function() {
        // Fetch resources to populate the resources model
        CudaLaunch.models.resources.refresh();
    });

    $(document).on("userunauthenticated", function() {
        CudaLaunch.models.resources.reset();
    });

    $(document).on("appinit", function() {
        const navManager = CudaLaunch.navManager = new NavigationManager();
        const rootController = new RootController(navManager, CudaLaunch.clientConfiguration);
        CudaLaunch.controllers["RootController"] = rootController;
        rootController.addDelegatingController(new FavouritesController());

        CudaLaunch.models.resources = new ResourcesModel();

        new ConnectionPlugin().start();
        new LogonPlugin(CudaLaunch.clientConfiguration).start();
        new AttributesPlugin().start();
        postal.publish({
            channel : "RootController",
            topic : "rootControllerLoaded",
            data : {controller : rootController}
        });
    });

    window["handleOpenURL"] = function(url) {
        console.debug("Received launch URL: " + url);

        if (url) {
            let host = url.substring("cudalaunch://".length);

            if (Utils.isValidHostname(host)) {
                handleHostnameChangeDelegate(host);
            } else {
                console.error("Invalid hostname received via launch URL:" + host);
            }
        }
    };

    window["handleHostnameChangeDelegate"] = function(hostname) {
        App.setHostname(hostname);
        console.debug("Changing hostname to: " + hostname);
    };

    // 'deviceready' will run immediately if the event has already been fired, so add the event listener on mobileinit so that
    // we are confident jQuery Mobile has been loaded before we start loading our code
    $(document).on("mobileinit", function() {
        // Stop jQuery Mobile from auto initializing. We will manually do this after any extra bits of the app have been configured
        $.mobile.autoInitializePage = false;

        document.addEventListener("deviceready", function() {
            $(document).trigger("frameworkready");
        }, false);
    });
}

module.exports = CudaLaunchApp;